export const UPDATE_REVIEW_CYCLE_CONFIG = "UPDATE_REVIEW_CYCLE_CONFIG";
